import styled from 'styled-components';
import { Col } from 'base/src/components/Basic/Col/col';
import { Row } from 'base/src/components/Basic/Row/row';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: clamp(1.25rem, 3vw, 3.125rem);  
  padding-block: clamp(0.75rem, 1.5vw, 1.25rem);  
  gap: clamp(0.75rem, 1.5vw, 1.25rem);

  @media (max-width: 768px) {
    padding-inline: clamp(0.75rem, 1.5vw, 1.25rem);
  }
`;

export const CarteiraCol = styled(Col)`
  display: flex;
  flex-direction: row;
  gap: 30px;
  width: 100%;
`;

export const CarteiraRow = styled(Row)`
  background: ${props => props.theme.colors.background};
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 60%;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 25px;
`;

export const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const OptionTitle = styled.h4`
  margin: 0;
  color: ${props => props.theme.colors.text};
  font-size: 16px;
  font-weight: 600;
`;

export const OptionSubTitle = styled.p`
  margin: 0;
  color: ${props => props.theme.colors.textSecondary};
  font-size: 14px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 25px;
`;

